module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/communication/safe-chat-83b7ca551ab7cb683be2078909b12080.svg";